const Storage = require('./storage');
const { getPersonTypeAndCode } = require('./hash');
const {
    PAGE_GENERIC,
    PROC_COMMERCIAL_SPACE,
    PROC_CANCEL,
    PAGE_ERROR
} = require('../constants/tagging');

/*
    Constants are defined ONLY for those wizards that do not have a 1-to-1 relationship to paths
    If a wizard is used in two or more paths, or if at a path you use two or more wizards, you
    must define a constant, and pass it to the wizard in props.
*/

let lastPath = '';

//TODO: Move this polyfill to a babel plugin
//NOTE: This polyfill is necessary because phantom fails with "undefined is not a function"
if (!String.prototype.startsWith) {
    String.prototype.startsWith = function (searchString, position) {
        position = position || 0;
        return this.substr(position, searchString.length) === searchString;
    };
}

const nullFunction = () => { };

const sendOutUtagData = (isEvent) => {
    window.utag_data.ipUsuario = window.utag_ip;

    const oldConsoleLog = window.console.log;
    const oldConsoleInfo = window.console.info;

    window.console.log = nullFunction;
    window.console.info = nullFunction;

    if (isEvent) {
        window.utag && window.utag.link && window.utag.link(window.utag_data);
    } else {
        window.utag && window.utag.view && window.utag.view(window.utag_data);
    }

    window.console.log = oldConsoleLog;
    window.console.info = oldConsoleInfo;
};

const saveLastPath = path => {
    if (path) {
        if (!path.startsWith('/')) {
            path = `/${path}`;
        }

        if (!path.endsWith('/')) {
            path = `${path}/`;
        }

        lastPath = path.substr(1, path.length - 2);
    } else {
        lastPath = '';
    }
};

const forceSendCommon = () => {
    if (!!window.utag_ip) {
        while (window.utag_pending.length) { // send any pending, cached tags
            window.utag_data = window.utag_pending.pop();
            sendOutUtagData();
        }
    }
}

const checkUser = (user) => {
    let response;
    try {
        response = !!Storage.cookies.get(user);
    } catch (e) {
        response = false;
    }
    return response;
};

const doTagging = (gaTags, isEvent, isContactCenter, isProduction, isOculto, tokenCredential) => {
    /*
        Google Analytics tagging
        FROM DIVISADERO'S ORIGINAL (SPANISH LANGUAGE) DOCUMENTATION:

        NOTA: Es importante que los valores de las claves cargadas en utag_data se carguen
        en minúsculas y evitando caracteres extraños o poco convencionales, especialmente
        tildes, comillas, eñes y cualquiera de los siguientes caracteres: &=/\<>+/ \ <>.
        Se recomienda utilizar una codificación de caracteres bajo el estándar UTF-8.

        tipoPagina: '', // <pagina generica|pagina de error|pagina de producto|pagina de inicio>
        nombrePagina: '', // <pathname de la página actual | miga de pan>
        zonaWeb: 'zona privada', // <zona publica | zona privada | onboarding>
        versionSitio : '' // <desktop|tablet|mobile>
        tipoUsuario : 'cliente', // <cliente | prospecto>
        estadoUsuario: 'logado', // <logado | no logado>
        identificadorUsuario: '', // <identificador del usuario>
        neruda: '',
        tipoError : '' // <400|404|500|502…>
        tipoProceso : ''
        pasoProceso : ''

        ipUsuario : '' // IP, encriptada
      */
    if (!isEvent) {
        // addPageViewToQueue({}); // record event stream for Big Data processing
        saveLastPath(gaTags.nombrePagina);
    }

    try {
        const personTypeAndCode = getPersonTypeAndCode(isContactCenter, tokenCredential);
        if (personTypeAndCode.type && personTypeAndCode.f) {
            gaTags.identificadorUsuario = `${personTypeAndCode.type}${Number(personTypeAndCode.f)}`;
        }
    } catch(e) {}

    if (!!gaTags.identificadorUsuario) {
        gaTags.neruda = checkUser('neruda');
        gaTags.ares = checkUser('ares');
    }
    
    gaTags.tipoUsuario = 'cliente';
    gaTags.estadoUsuario = 'logado';
    gaTags.zonaWeb = 'zona privada';
    gaTags.versionSitio = 'desktop';

    try {
        gaTags.segmento = Storage.localStorage.get('segmentDigilant', isContactCenter, isProduction, isOculto);
    } catch (e) {
        gaTags.segmento = '';
    }

    if (!!window.utag_ip) {
        while (window.utag_pending.length) {
            // send any pending, cached tags
            window.utag_data = window.utag_pending.pop();
            sendOutUtagData(isEvent);
        }
        if (window.utag_data !== null && window.utag_data !== undefined) {
            Object.assign(window.utag_data, gaTags); // send latest tags
            sendOutUtagData(isEvent);
        }
    } else {
        // cache tags for later
        if (window.utag_data !== null && window.utag_data !== undefined) {
            Object.assign(window.utag_data, gaTags);
            window.utag_pending.push(Object.assign({}, window.utag_data));
        }
    }
};

// Generates a TAG EVENT (The only one!)
const recordLinkCommon = (
        eventCategory = '',
        eventName = '',
        eventTag = '',
        isProduction = false,
        isContactCenter = false,
        isOculto = false,
        tokenCredential
    ) => {



    const taggingData = {
        tipoPagina: window.utag_last_type,
        nombrePagina: window.utag_last_name,
        tipoError: '',
        tipoProceso: '',
        pasoProceso: '',
        categoriaEvento: eventCategory,
        accionEvento: eventName,
        etiquetaEvento: eventTag,
    }

    doTagging(taggingData, true, isContactCenter, isProduction, isOculto, tokenCredential);

    if (isProduction) {
        window.console.info('Tealium:recordLink', taggingData);
    }

    window.utag_saved_tags = null;
};

const recordLinkCommonV2  = (customData = {}, isProduction) => {
    const taggingData = {
        tipoPagina: window.utag_last_type,
        nombrePagina: window.utag_last_name,
        tipoError: '',
        tipoProceso: '',
        pasoProceso: '',
        ...customData
    }

    doTagging(taggingData, true);

    if (isProduction) {
        window.console.info('Tealium:recordLink', taggingData);
    }

    window.utag_saved_tags = null;
};

const recordPathCommon = (
    pathForTag,
    pageType = PAGE_GENERIC,
    procType = '',
    procStep = '',
    nameProduct = null,
    isProduction = false,
    isContactCenter = false,
    isOculto = false,
    tokenCredential,
    preapprovedId = '',
    processDetails = '',
    descriptionError = '',
    categoryError = '',
    profileInvestor = ''
) => {
    window.utag_last_name = pathForTag;
    window.utag_last_type = pageType;
    saveLastPath(pathForTag);

    const processDetail = processDetails || pathForTag.split('/').pop();

    const taggingData = {
        nombrePagina: pathForTag,
        tipoPagina: pageType,
        tipoError: '',
        tipoProceso: procType,
        pasoProceso: procStep,
        detalleProceso: processDetail,
    }

    if (descriptionError) taggingData.descripcionError = descriptionError;
    if (categoryError) taggingData.categoriaError = categoryError;
    if (nameProduct) taggingData.nombreProducto = nameProduct;
    if (!!preapprovedId) taggingData.idPreaprob = preapprovedId;
    if (!!profileInvestor) taggingData.profileInvestor = profileInvestor;
    doTagging(taggingData, false, isContactCenter, isProduction, isOculto, tokenCredential);

    if (isProduction) {
        window.console.info('Tealium:recordPath', taggingData);
    }

    window.utag_saved_tags = null;
};

const recordCommercialSpaceCommon = (params, category = PROC_COMMERCIAL_SPACE, isProduction = false, isContactCenter = false, isOculto = false, tokenCredential) => {
    const taggingData = {
        categoriaEvento: category,
        tituloEspacio: params.title || '',
        cuerpoEspacio: params.body || '',
        huecoEspacio: params.spaceId || ''
    }

    doTagging(taggingData, true, isContactCenter, isProduction, isOculto, tokenCredential);
    if (isProduction) {
        window.console.info('Tealium:recordAd', taggingData);
    }
}

const recordCommercialSpaceCommonV2 = (params, customData = {}, isProduction = false, isContactCenter = false, isOculto = false, tokenCredential) => {
    const taggingData = {
        categoriaEvento: params.categoriaEvento || '',
        accionEvento: params.accionEvento || '',
        tealium_event: params.tealiumEvent || '',
        ...customData
    }

    doTagging(taggingData, true, isContactCenter, isProduction, isOculto, tokenCredential);

    if (isProduction) {
        window.console.info('Tealium:recordAd', taggingData);
    }
}

const recordProcessCommon = (
        proc,
        step,
        customData = {},
        isProduction = false,
        isContactCenter = false,
        isOculto = false,
        tokenCredential,
        isSecondVersion = false
    ) => {
    /*
        If the process name isn't given, assume it's
        a process that's done only at one place,
        so use the current path, changing '/' to '-'.

        This helps NOT having to change every wizard!
    */

    const taggingData = isSecondVersion ?
        {
            tipoPagina: window.utag_last_type,
            nombrePagina: window.utag_last_name,
            tipoError: '',
            tipoProceso: proc || `proc-${lastPath.replace(/\//g, '-')}`,
            pasoProceso: step,
            ...customData
        }
        :
        {
            tipoPagina: window.utag_last_type,
            nombrePagina: window.utag_last_name,
            tipoError: '',
            tipoProceso: proc || `proc-${lastPath.replace(/\//g, '-')}`,
            pasoProceso: step,
            categoriaEvento: customData.eventCategory || '',
            accionEvento: customData.eventName || '',
            etiquetaEvento: customData.eventTag || '',
            detalleProceso: customData.processDetail || '',
            idPreaprobPP: customData.idPreaprobPP || ''
        }

    if (!isSecondVersion && customData.productName) taggingData.nombreProducto = customData.productName;
    if (!isSecondVersion && customData.descriptionError) taggingData.descripcionError = customData.descriptionError;
    if (!isSecondVersion && customData.categoryError) taggingData.categoriaError = customData.categoryError;

    doTagging(taggingData, false, isContactCenter, isProduction, isOculto, tokenCredential);

    if (isProduction) {
        window.console.info('Tealium:recordProcess', taggingData);
    }

    window.utag_saved_tags = {
        tipoPagina: window.utag_last_type,
        nombrePagina: window.utag_last_name,
        tipoProceso: proc || `proc-${lastPath.replace(/\//g, '-')}`
    };
};

const recordCancellationCommon = (tokenCredential) => {
    window.utag_saved_tags &&
        doTagging({
            tipoPagina: window.utag_saved_tags.tipoPagina,
            nombrePagina: window.utag_saved_tags.nombrePagina,
            tipoError: '',
            tipoProceso: window.utag_saved_tags.tipoProceso,
            pasoProceso: PROC_CANCEL
        }, false, false, false, false, tokenCredential);

    window.utag_saved_tags = null;
};

const recordErrorCommon = (errCode, isContactCenter, tokenCredential) => {
    window.utag_last_name = '';
    window.utag_last_type = '';

    doTagging({
        tipoPagina: PAGE_ERROR,
        nombrePagina: 'error',
        tipoError: errCode,
        tipoProceso: '',
        pasoProceso: ''
    }, false, isContactCenter, false, false, tokenCredential);
};

const recordEvent = (eventCategory, actionEvent = '', tagEvent = '', additionalData = {}) => {
    const output = {
        categoriaEvento: eventCategory,
        accionEvento: actionEvent,
        etiquetaEvento: tagEvent,
        ...additionalData
    }
    window.utag && window.utag.link && window.utag.link(output);
}

const recordView = (pageName, processType = '', processStep = '', additionalData = {}) => {
    const output = {
        nombrePagina: pageName,
        tipoProceso: processType,
        pasoProceso: processStep,
        ...additionalData
    }

    window.view && window.view.link && window.view.link(output);
}


module.exports = {
    forceSendCommon,
    recordCancellationCommon,
    recordErrorCommon,
    recordEvent,
    recordLinkCommon,
    recordLinkCommonV2,
    recordPathCommon,
    recordProcessCommon,
    recordCommercialSpaceCommon,
    recordCommercialSpaceCommonV2,
    recordView
};
